/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import { store } from "@/store.js";

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
// Import Bootstrap an BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
export const keyevent = new Vue();
export const scroll = new Vue();
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)


//Модальные окна на iPhone и iPad
import PortalVue from 'portal-vue';
Vue.use(PortalVue)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  created() {
    if (store.companyName) {
      document.title = store.companyName || 'qrMenu';      
    } else {
      this.$watch(
        () => store.companyName,
        (newVal) => {
          if (newVal) document.title = newVal || 'qrMenu'
          else document.title = 'QR меню'
        }
      );
    }
  }
}).$mount('#app')
// new Vue({
//   store,
//   render: h => h(App),
//   created() {
//     // Перевіряємо, чи є companyName
//     if (store.companyName) {
//       document.title = store.companyName;
//     } else {
//       // Якщо companyName ще немає, чекаємо, поки він з'явиться
//       this.$watch(
//         () => store.companyName,
//         (newVal) => {
//           if (newVal) {
//             document.title = newVal;
//           }
//         }
//       );
//     }
//     let aaa='Pizza House'
//     // Перевіряємо, чи є адреса, якщо потрібно додати її до заголовка
//     if (!store.companyName && !store.address) {
//       document.title = "QR-Menu";
//       this.$watch(
//         () => store.companyName + 'Оберіть дію',
//         (newVal) => {
//           if (newVal) {
//             document.title = (aaa + '' +'-' +'Оплата замовлення');
//           }
//         }
//       );
//     }
//   }
// }).$mount('#app');

